import { render, staticRenderFns } from "./lista_documentos.vue?vue&type=template&id=588249b2"
import script from "./lista_documentos.vue?vue&type=script&lang=js"
export * from "./lista_documentos.vue?vue&type=script&lang=js"
import style0 from "./lista_documentos.vue?vue&type=style&index=0&id=588249b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports